<template>
  <div class="form-insert">
    <h4>{{L10n('add-new')}}</h4>
    <form-editor
      :data="data"
      :model="formModel"
      :list="list"
      @command="commandController"
      ref="Form"
    />
    </div>
</template>

<script>

export default {
  name: 'EditorAddToRFQ3',
  components: {
    'form-editor': () => import(/* webpackChunkName: 'Shared' */ './Form')
  },
  props: {
    config: { required: true },
    dataRFQ: { type: Object },
    list: { type: Array, required: true }
  },
  data () {
    return {
      isLoading: false,
      data: {}
    }
  },
  computed: {
    formTitle () {
      return this.L10n('add-new')
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        rfqid: this.dataRFQ.rfqid,
        observation: '',
        qty: 1,
        partID: null
      }
    },
    commandController (command) {
      if (command === 'save') {
        this.create()
      }
    },
    resetData () {
      this.data = {}
    },
    create () {
      this.$refs.Form.validate()
        .then(() => {
          this.isLoading = true
          let data = { ...this.$refs.Form.getData(), rfqid: this.dataRFQ.rfqid }
          this.$bus.$emit(`Call-Grid-Create-${this.config.id}`, data, this.gridCreateHandler)
        })
    },
    gridCreateHandler (response, isEditAfter) {
      this.isLoading = false
      this.resetData()
    }
  }
}
</script>
